import {
    AccommodationAdditionalFiltersModel,
    AccommodationAdvancedFiltersModel,
} from './accommodation-filters.model';
import { RatingDescription } from './rating-description.model';
import { ReservationTypeEnum } from './reservation-type.model';

export enum AccommodationItemVariantEnum {
    Map = 'map',
    NearbyOta = 'nearbyOta',
}

export interface AccommodationItemModel {
    id: string;
    name: string;
    path: string;
    images: { default: boolean; url: string }[];
    settlementName: string;
    distanceFromCityCentre: number | null;
    ratingsAverage?: number;
    ratingDescription?: RatingDescription;
    ratingsCount: number;
    cheapestRate: {
        rate: number;
        baseRate: number;
        guests: number;
        children: number;
        childrenAges?: number[];
        duration: number;
        currency: string;
        checkIn?: string;
        checkOut?: string;
    };
    filters?: AccommodationAdvancedFiltersModel;
    additionalFilters?: AccommodationAdditionalFiltersModel;
    checkInDate?: Date;
    checkOutDate?: Date;
    reservationType?: ReservationTypeEnum;
    variant?: AccommodationItemVariantEnum;
    isUnavailable?: boolean;
}
